import {ActionContext, Module} from "vuex";
import {RootState} from "@/store/index";
import {WoodFrame, woodFrameApi} from "@/api/woodFrame";

export interface WoodframeState {
  woodFrames: WoodFrame[];
}

const woodFrameModule: Module<WoodframeState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      woodFrames: [] as WoodFrame[],
    } as WoodframeState),
  mutations: {
    setWoodFrames(state: WoodframeState, woodFrames: WoodFrame[]): void {
      state.woodFrames = woodFrames;
    },
  },
  actions: {
    async listAll(
      context: ActionContext<WoodframeState, RootState>
    ): Promise<void> {
      if (!context.state.woodFrames || context.state.woodFrames.length === 0) {
        context.commit("setWoodFrames", await woodFrameApi.list());
      }
    },
    async addWoodFrame(
      context: ActionContext<WoodframeState, RootState>,
      woodFrame: WoodFrame
    ): Promise<void> {
      await woodFrameApi.add(woodFrame)
      context.commit("setWoodFrames", await woodFrameApi.list());
    },
    async editWoodFrame(
      context: ActionContext<WoodframeState, RootState>,
      woodFrame: WoodFrame
    ): Promise<void> {
      if (woodFrame.id) {
        await woodFrameApi.edit(woodFrame);
        context.commit("setWoodFrames", await woodFrameApi.list());
      }
    },
    async removeWoodFrame(
      context: ActionContext<WoodframeState, RootState>,
      woodFrame: WoodFrame
    ): Promise<void> {
      if (woodFrame.id) {
        await woodFrameApi.delete(woodFrame)
        context.commit("setWoodFrames", await woodFrameApi.list());
      }
    },
  },
};

export default woodFrameModule;
